import { ArrowUpRight } from "lucide-react";

// External link: always opens in a new tab.
export const ExtLink = ({ href, children, className = "", testId }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={`group/ext inline-flex items-center gap-1.5 font-medium text-accent underline-offset-4 hover:underline ${className}`}
    data-testid={testId}
  >
    {children}
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover/ext:-translate-y-0.5 group-hover/ext:translate-x-0.5" />
  </a>
);
